/**
 * Mozaik's level map: the shared arcade saga map (`@kit/map`, apps/arcade/src/kit) configured for Mozaik.
 * Map → level → back to the map with the result; "‹ Oyunlar" leads to the games list, as in every game.
 */
import { levelMapScene, mapKey } from "@kit/map";
import { classicGoal, classicLevel } from "./classic";
import { loadProgress } from "./progress";
import { track } from "./telemetry";
import { lang } from "./i18n";

export const MAP_ID = "mozaik";
export const MAP_SCENE = mapKey(MAP_ID);

export const MozaikMap = levelMapScene({
  id: MAP_ID,
  gameScene: "game",
  title: { tr: "Mozaik", en: "Mozaik" },
  accent: 0xffca3a,
  firstTheme: 3,
  track,
  lang: () => lang,
  // Before the map, `mozaik.progress.levelIndex` was the next level (0-based).
  legacyLevel: () => loadProgress().levelIndex + 1,
  describe: (n, lang) => classicGoal(classicLevel(n - 1), lang),
});
